import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "customer-forecast-timeline" }
const _hoisted_2 = { class: "customer-forecast-timeline__top-container top-container" }
const _hoisted_3 = { class: "customer-forecast-timeline__filter-container filter-container" }
const _hoisted_4 = { class: "filter-container__filter-contents" }
const _hoisted_5 = { class: "filter-container__footer" }
const _hoisted_6 = { class: "customer-forecast-timeline__sub-button-container sub-button-container" }
const _hoisted_7 = { class: "sub-button-container__target-month-select" }
const _hoisted_8 = { class: "sub-button-container__description-label-container description-label-container" }
const _hoisted_9 = { class: "description-label-container__label description-label-container__label--forecast" }
const _hoisted_10 = { class: "description-label-container__label-set-container" }
const _hoisted_11 = { class: "description-label-container__label description-label-container__label--sales-result" }
const _hoisted_12 = { class: "description-label-container__label description-label-container__label--sales-result description-label-container__label--sales-result--suffix" }
const _hoisted_13 = { class: "download-button__container" }
const _hoisted_14 = { class: "download-button__text" }

import { i18n } from '@/i18n';
import { CUSTOMER_TAB_ROUTER_INFO } from '../constants';
import ControlCustomerPageTab from '../components/ControlCustomerPageTab.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useCustomerForecastTimelineStore } from './useCustomerForecastTimelineStore';
import { storeToRefs } from 'pinia';
import SingleSelectInput from '@/corePagesModule/SelectInput/SingleSelectInput.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { computed, onMounted, watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import ForecastTimelineTable from '@/corePagesModule/components/forecastTimelineTable/ForecastTimelineTable.vue';
import { CustomerForecastTimelineTableStateAdapter } from '../adapter/customerForecastTImelineTableStateAdapter';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import { useRoute } from 'vue-router';
import DownloadTimelineModal from '../components/DownloadTimelineModal.vue';
import { CustomerForecastTimelineViewModel } from './customerForecastTimelineViewModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerForecastTimeline',
  setup(__props) {

const t = i18n.t;
const locale = computed(() => i18n.locale);
const route = useRoute();
const store = useCustomerForecastTimelineStore();
const { state } = storeToRefs(store);
const repository = new CustomerForecastRepository();
const vm = new CustomerForecastTimelineViewModel();

onMounted(async () => {
  const businessId = typeof route.params.defaultBusinessId === 'string' ? route.params.defaultBusinessId : undefined;
  await init(businessId);
});

/**
 * 初期化処理
 * @param businessId - 取引ID
 */
const init = async (businessId?: string) => {
  await store.init(repository, businessId);
};

/**
 * 内示遍歴ページのまま取引IDが変更された際に再取得処理を行う
 * ex. 前月差異から遷移後、内示遍歴タブを押した場合、取引IDが選択されていない状態になるため、再度初期化
 */
watch(
  () => route.params.defaultBusinessId,
  async (newValue) => {
    const businessId = typeof newValue === 'string' ? newValue : undefined;
    await init(businessId);
  }
);

// フィルタ項目が変更された際に適用ボタンのdisabledを必要に応じて更新する
watch(
  () => state.value.filterContentsInfo.filterItems,
  (newValue) => {
    store.updateIsDisabledApplyFilterButton(newValue);
  },
  { deep: true }
);

/**
 * ダウンロードボタンのdisabled判定
 */
const isDisabledDownloadButton = computed(() => {
  return state.value.tableItems === undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ControlCustomerPageTab, {
          class: "top-container__tab-bar",
          "tab-info-object": [..._unref(CUSTOMER_TAB_ROUTER_INFO)]
        }, null, 8, ["tab-info-object"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "filter-container__clear-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).onClickClearFilterButton && _unref(store).onClickClearFilterButton(...args)))
        }, _toDisplayString(_unref(t)('すべての選択状態をクリア')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).filterContentsInfo.filterItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "filter-container__filter-item filter-item"
            }, [
              _createVNode(SingleSelectInput, {
                class: "filter-item__select-input",
                index: 2 + index,
                "model-value": item.selectedValue,
                placeholder: _unref(t)('選択してください'),
                label: item.i18nOptions ? _unref(t)(item.label, item.i18nOptions) : _unref(t)(item.label),
                "filter-type": item.filterType,
                "is-open-prop": _unref(state).filterContentsInfo.currentFilterType === item.filterType,
                "prop-customer-forecast-filter-property": _unref(store).getFilterProperty(),
                "use-teleport": "",
                "onClick:selectInput": () => (_unref(state).filterContentsInfo.currentFilterType = item.filterType),
                "onUpdate:modelValue": (e) => (_unref(state).filterContentsInfo.filterItems[index].selectedValue = e)
              }, null, 8, ["index", "model-value", "placeholder", "label", "filter-type", "is-open-prop", "prop-customer-forecast-filter-property", "onClick:selectInput", "onUpdate:modelValue"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextButton, {
            class: "filter-container__apply-button",
            "button-style": 'btn-primary',
            size: 'btn-md',
            "on-click": () => _unref(store).onClickApplyFilterButton(_unref(repository)),
            disabled: _unref(state).isDisabledApplyFilterButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('適用')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(MonthPicker, {
            class: "sub-button-container__calendar customer-forecast-timeline-calendar",
            "model-value": _unref(state).targetStartYearMonth,
            locale: locale.value,
            "prop-format": _unref(t)('MonthPickerFormat'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(store).onSelectedStartYearMonth($event, _unref(repository))))
          }, null, 8, ["model-value", "locale", "prop-format"]),
          _createTextVNode(" " + _toDisplayString(_unref(t)('~')) + " ", 1),
          _createVNode(SelectInput, {
            class: "sub-button-container__select-input",
            index: 1,
            "model-value": _unref(t)('displayMonthsOfData', { month: _unref(state).displayForecastsMonth }),
            placeholder: '',
            label: '',
            "filter-type": 'DISPLAY_MONTH',
            "prop-options": _unref(store).getMonthsDisplayForecast(),
            "is-open-prop": _unref(state).openedSelectInputType === 'DISPLAY_MONTH',
            "use-teleport": "",
            "onClick:selectInput": _cache[2] || (_cache[2] = () => (_unref(state).openedSelectInputType = 'DISPLAY_MONTH')),
            "onUpdate:valueWithIndex": _cache[3] || (_cache[3] = (_, index) => _unref(store).onSelectedDisplayForecastsMonth(index, _unref(repository)))
          }, null, 8, ["model-value", "prop-options", "is-open-prop"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('黒文字：客先内示')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('青文字：')), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('販売実績')), 1)
          ])
        ]),
        _createVNode(TextButton, {
          class: "sub-button-container__download-button download-button",
          disabled: true,
          onClick: _cache[4] || (_cache[4] = () => (_unref(state).downloadModalState.modalState = true))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('ダウンロード')), 1),
              _createVNode(SvgLoader, {
                class: "download-button__icon",
                name: "fatArrowDown"
              })
            ])
          ], undefined, true),
          _: 1
        })
      ]),
      _createVNode(ForecastTimelineTable, {
        class: "customer-forecast-timeline__table-container",
        "header-month-list": _unref(state).targetYearMonthList,
        "row-month-list": _unref(state).receivedYearMonthList,
        "table-item-data": _unref(state).tableItems !== undefined ? _unref(CustomerForecastTimelineTableStateAdapter).adapt(_unref(state).tableItems) : undefined,
        "prop-loading-state": _unref(state).tableLoadingState,
        onReload: _cache[5] || (_cache[5] = ($event: any) => (_unref(store).updateDisplayData(_unref(repository))))
      }, null, 8, ["header-month-list", "row-month-list", "table-item-data", "prop-loading-state"])
    ]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).fetchBaseBusinessIdLoadingState.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引情報を取得中')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"])
  ], 64))
}
}

})